import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Expand = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M14.4891 0.441513H1.84629C1.07046 0.441515 0.441528 1.07045 0.441526 1.84628L0.441528 14.4891C0.441528 15.265 1.07046 15.8939 1.84629 15.8939C2.62212 15.8939 3.25105 15.265 3.25105 14.4891L3.25105 5.23767L16.2494 18.236C17.5433 19.0254 19.0247 17.5446 18.2368 16.2506L25.1892 23.203C23.8953 22.4136 22.4138 23.8944 23.2018 25.1885L36.2009 38.1875H26.9495C26.1736 38.1875 25.5447 38.8165 25.5447 39.5923C25.5447 40.3681 26.1736 40.9971 26.9495 40.9971H39.5923C40.3681 40.9971 40.9971 40.3681 40.9971 39.5923L40.9971 26.9495C40.9971 26.1736 40.3681 25.5447 39.5923 25.5447C38.8165 25.5447 38.1876 26.1736 38.1876 26.9495V36.2009L5.23769 3.25104L14.4891 3.25104C15.265 3.25104 15.8939 2.6221 15.8939 1.84628C15.8939 1.07045 15.265 0.441515 14.4891 0.441513Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
